import CreateOrUpdateMedicineItemForm from 'components/Form/Tenant/Items/CreateOrUpdateMedicineItemForm';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

const ShopItemFormPage: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  return (
    <div className="page-content">
      <Container fluid>
        <CreateOrUpdateMedicineItemForm id={id} />
      </Container>
    </div>
  );
};

export default ShopItemFormPage;
